/**
 * @param {Function} fn 防抖函数
 * @param {Number} delay 延迟时间
 */
export function debounce (fn, delay) {
  var timer
  return function () {
    var context = this
    var args = arguments
    clearTimeout(timer)
    timer = setTimeout(function () {
      fn.apply(context, args)
    }, delay)
  }
}

/**
 * @param {date} time 需要转换的时间
 * @param {String} fmt 需要转换的格式 如 yyyy-MM-dd、yyyy-MM-dd HH:mm:ss
 */
export function formatTime (time, fmt) {
  if (!time) {
    return ''
  } else {
    const date = new Date(time)
    const o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),

      'H+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds(),
      'q+': Math.floor((date.getMonth() + 3) / 3),
      S: date.getMilliseconds()
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + '').substr(4 - RegExp.$1.length)
      )
    }
    for (const k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1
            ? o[k]
            : ('00' + o[k]).substr(('' + o[k]).length)
        )
      }
    }
    return fmt
  }
}

/**
 * @function deepClone 浅拷贝转深拷贝
 * @param {option} target 需要拷贝的对象
 */
export function deepClone (target) {
  var result
  // 判断是否是对象类型
  if (typeof target === 'object') {
    // 判断是否是数组类型
    if (Array.isArray(target)) {
      result = [] // 如果是数组,创建一个空数组
      // 遍历数组的键
      for (let i in target) {
        // 递归调用
        result.push(deepClone(target[i]))
      }
    } else if (target === null) {
      // 再判断是否是 null
      // 如果是，直接等于 null
      result = null
    } else if (target.constructor === RegExp) {
      // 判断是否是正则对象
      // 如果是,直接赋值拷贝
      result = target
    } else if (target.constructor === Date) {
      // 判断是否是日期对象
      // 如果是,直接赋值拷贝
      result = target
    } else {
      // 则是对象
      // 创建一个空对象
      result = {}
      // 遍历该对象的每一个键
      for (let i in target) {
        // 递归调用
        result[i] = deepClone(target[i])
      }
    }
  } else {
    // 表示不是对象类型，则是简单数据类型  直接赋值
    result = target
  }
  // 返回结果
  return result
}

export function fix (num, length) {
  return ('' + num).length < length ? ((new Array(length + 1)).join('0') + num).slice(-length) : '' + num
}



// WEBPACK FOOTER //
// ./src/utils/index.js